import { render, staticRenderFns } from "./liberacaoautomatica.vue?vue&type=template&id=a7785d72&scoped=true&"
import script from "./liberacaoautomatica.vue?vue&type=script&lang=js&"
export * from "./liberacaoautomatica.vue?vue&type=script&lang=js&"
import style0 from "./liberacaoautomatica.vue?vue&type=style&index=0&id=a7785d72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7785d72",
  null
  
)

export default component.exports